export default {
  defaultHeading: '',
  careLogo: {
    imageAlt: 'CARE International',
  },
}
